// hooks/cityContext.js
import { createContext, useContext, useState, useEffect } from "react";

const CityContext = createContext();

export const CityProvider = ({ children }) => {
  const [selectedCity, setSelectedCity] = useState("");

  useEffect(() => {
    const savedCity = localStorage.getItem("location");
    if (savedCity) {
      setSelectedCity(savedCity);
    }
  }, []);

  const changeCity = (city) => {
    setSelectedCity(city);
    localStorage.setItem("location", city);
  };

  return (
    <CityContext.Provider value={{ selectedCity, changeCity }}>
      {children}
    </CityContext.Provider>
  );
};

export const useCity = () => useContext(CityContext);
